import { MediaThumbnailLine } from 'Components/lines/media-thumbnail-line/MediaThumbnailLine';
export default MediaThumbnailLine;
